import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Stack, Box, Typography, useTheme, Button, styled, } from "@mui/material";
import {Badge, theme} from "@material-ui/core";
import Select from "react-select";
import { DataGrid } from "@mui/x-data-grid";
import urls from '../../constants/urls';



const TXTRoundedDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    //height: "100%",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));

const TXTNonVisibleDiv= styled("div")(({theme})=>({
    //borderRadius: theme.shape.borderRadius,
    //border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    //height: "100%",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));

const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"

});

const StyledSelect= styled(Select)({
    fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});



export default function SchoolOwnersAddSchool( { users_id, full_name,  mobile_number,  user_password  } ) {
  
  const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);

  const [schools, setSchools]=useState([]);

  const [organizationSchoolsData, setOrganizationSchoolsData]=useState([]);

  const [subClasses, setSubClasses]=useState([]);

  const [refreshIt, setRefreshIt]=useState(false);
  
  const [buttonClicked, setButtonClicked]=useState(false)

  const [academicYears, setAcademicYears]=useState([]);

  const [subjects, setSubjects]=useState([]);

  //
  const [usersIdEXT, setUsersIdEXT]=useState(users_id);
 
  const [formDataUserLoginEXT, setFormDataUserLoginEXT]=useState({
        id: 1,
        school: 0,
        organization: usersIdEXT,
        status: 'Active',
        
    })

  //validateForm

  const [cities, setCities]=useState([]);
  const [city, setCity]=useState('Select city');
  
  const [districts, setDistricts]=useState([]);
  const [districtsOG, setDistrictsOG]=useState([]);
  const [district, setDistrict]=useState('');
  
  const [wards, setWards]=useState([]);
  const [wardsOG, setWardsOG]=useState([]);
  const [ward, setWard]=useState('');
  
  
  
  const [errors, setErrors]=useState({});

  const [patientGender, setPatientGender]=useState(
    [
    {label :'Select gender', value:'Select gender', name: 'gender' },
    {label :'Male', value:'Male', name: 'gender' },
    {label :'Female', value:'Female', name: 'gender' },
    ]
);
  

  const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
    }
    };

  const reloadDistricts=(cityId)=>{
   let newList=[]
    newList=districtsOG.filter(districtsOG=>districtsOG.city_id===cityId);
    setDistricts(newList);
  }
  
  const reloadWards=(districtId)=>{
    let newList=[]
     newList=wardsOG.filter(wardsOG=>wardsOG.district_id===districtId);
     setWards(newList);
    
   }

 
   const handleChangeSelect = (e) =>{
    const {name, value } = e
    
    //console.log("e.target.name=" + e.target.name)
    console.log("name=" + name +  ", value=" + value)

    if(name==="school"){
      setFormDataUserLoginEXT({
      ...formDataUserLoginEXT,
      school: e.id
      })
     }
    
    if(name==="sub_class"){
        setFormDataUserLoginEXT({
        ...formDataUserLoginEXT,
        sub_class_id: e.id
        })
    }

   if(name==="subject"){
    setFormDataUserLoginEXT({
        ...formDataUserLoginEXT,
        subject_id: e.id
        })
  
    }
    
   setErrors({});
    
  }

  
 
 const handleChangeInput = (e) =>{
   const {name, value } =e.target
   setFormDataUserLoginEXT({
    ...formDataUserLoginEXT,
    [name]: value
   })
   //
   
   //
   setErrors({});
 }


 const DeleteSchoolFromOwner=(ssouId )=>{
   
    let formDataEXT={
    ssou_id: ssouId ,
    users_id: 0,
    school_owner: 0,
    school_id: 0,
    school_name: 0,
    mobile_number: 0,
    user_password: 0,
    }
    //axios

    let APIURL= APIROOTURL + "DeleteSchoolFromOwnerViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formDataEXT, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        setButtonClicked(!buttonClicked)
        console.log("res.data=" + res.data);
        console.log("res.data=" + res.data.msg);

        if(res.data.msg==="School was successfully removed from the owner"){
          alert("School was successfully removed from the owner");
          setRefreshIt(!refreshIt)
        }
        //alert( res.data.msg);
        //console.log("res.data['id']=" + res.data['id']);
        //picsId=res.data['id'];

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));


    
 }
 /*** *
 "ssou_id": 1,
        "school_id": 7,
        "school_name": "Zigi",
        "users_id": 46,
        "school_owner": "Rashid Juma Ahmad",
        "mobile_number": "0711222444",
        "user_password": "0711222444"
        ***/
 const columns = [
    { 
      field: "id", 
      headerName: "SNo",
      flex:1,
    },
    {
      field: "school_owner",
      headerName: "SCHOOL OWNER",
      flex: 2,
    },
    
    {
      field: "school_name",
      headerName: "SCHOOL NAME",
      flex: 2,
      cellClassName: "name-column--cell",
    },
   
    
    {
      field: "ssou_id",
      headerName: "DELETE",
      flex: 1,
      renderCell: ({ row: { ssou_id} }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            //backgroundColor={}
            borderRadius="4px"
          >
            
            <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           //                             users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
           onClick={()=>DeleteSchoolFromOwner( ssou_id)}
           >
            Delete
            </Button>
          </Box>
        );
      },
    },
  ];
  
 


  
 
  const handleButtonUpdate = () =>{
    
   //console.log("formData.name=" + formData['name'])

    let newErrors=validateForm(formDataUserLoginEXT);
    setErrors(newErrors);
    
    console.log("errors.lenght=" + Object.keys(newErrors).length)
    if(Object.keys(newErrors).length===0){
      console.log("len0")
      UpdateSchool()
    }
    else{
      console.log("len1")
    }
    /***
    
    ***/

}


    
const validateFormOLD = (data) =>{
  const errors={};
  let regExp=/^[a-zA-Z0-9._]+@[a-z]+\.[a-z]{2-6}$/;
  
  let regExpPassword=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,10})/
  
  console.log("data=" + data)
  console.log("data.name=" + data.name)
  
  console.log("district=" + district)
  //if(!(data.service_category.toString()).trim()){
  if(data.name==="" || data.name==""){
    console.log("if " + ", data.name=" + data.name)
    errors.name='Please enter school name';
   }
   else{
    console.log("else " + ", data.name=" + data.name)
   }

  if(city==="Select city" || city=="Select city" || city=="" ){
    errors.city='Please select city';
  }

  if(district==="Select district" || district=="Select district" || district==""){
    errors.district='Please select district';
  }

  if(ward==="Select ward" || ward=="Select ward" || ward==""){
    errors.ward='Please select ward';
  }
  
  if(!(data.ward.toString()).trim()){
    errors.ward='Please select ward';
   }

   

   if(!(data.street.toString()).trim()){
    errors.street='Please enter street';
   }

   if(!(data.plot_number.toString()).trim()){
    errors.plot_number='Please enter plot number';
   }

   if(!(data.area_details.toString()).trim()){
    errors.area_details='Please enter area details';
   }

   if(!(data.telephone_number_1.toString()).trim()){
    errors.telephone_number_1='Please enter primary telephone 1';
   }

   if(!(data.telephone_number_2.toString()).trim()){
    errors.telephone_number_2='Please enter secondary telephone 2';
   }

   if(!(data.website.toString()).trim()){
    errors.website='Please enter website';
   }

  if(!(data.email.toString()).trim()){
     errors.email='Please enter email';
 }
 ///     (!/\S+@\S+\.\S+/.test(data.email)
 ///       /.+@.+\.[A-Za-z]+$/
 ///       /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/
 ///       /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
 ///       /^[a-zA-Z0-9._]+@[a-z]+\.[a-z]{2-6}$/
 /***
  if (!regExp.test(data.email)) {
     errors.email = 'Email is invalid';
    }
 ***/
 /*** *
 
 
 ***/
  return errors;
}   
        
  

   const UpdateSchool=()=>{
     
     
    //let url = API_URL;
    let APIURL= APIROOTURL + "UpdateSchoolsViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formDataUserLoginEXT, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data=" + res.data);
        console.log("res.data=" + res.data.msg);
        alert( res.data.msg);
        //console.log("res.data['id']=" + res.data['id']);
        //picsId=res.data['id'];

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));


   }  
   
   

   
  const loadSchools=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select school', value: 'Select school', name: 'school'})
    {
        data.map(function(dt){
          newList.push({id: dt.school_id, label: dt.school_name, value: dt.school_name , name: 'school'})
        })
    }

    setSchools(newList)
  }
  

  /*** ***/
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "SchoolsViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json[0]=" + json[0]);
     loadSchools(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])
    /*****/
   



    
  const loadSubClasses=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select stream', value: 'Select stream', name: 'sub_class'})
    {
        data.map(function(dt){
          newList.push({id: dt.sub_class_id, label: dt.subclass_name, value: dt.subclass_name , name: 'sub_class'})
        })
    }

    setSubClasses(newList)
  }
  
  /** *
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "SingleSchoolSubClassViewEXT/" + schoolId
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json[0]=" + json[0]);
     loadSubClasses(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])
    ***/
  

    
    
  const loadAcademicYears=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select academic year', value: 'Select academic year', name: 'academic_year'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'academic_year'})
          console.log("dt.name=" + dt.name)
        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setAcademicYears(newList)
  }
  

  
  /*** *  
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "AcademicYearViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadAcademicYears(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])
    ***/
  
    

  const loadSubjects=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select subject', value: 'Select subject', name: 'subject'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'subject'})
          console.log("dt.name=" + dt.name)
        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setSubjects(newList)
  }
  

  
  /*** *  
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "SubjectsViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadSubjects(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])
    ***/





    const loadOrganizationSchoolsData=(data)=>{
        let newList=[]
        //newList.push({ id: 0, label: 'Select subject', value: 'Select subject', name: 'subject'})
        {
            data.map(function(dt, index){
                let xx=index+1
              newList.push(
                {
                id: xx,
                ssou_id: dt.ssou_id, 
                school_id: dt.school_id, 
                school_name: dt.school_name,
                users_id: dt.users_id , 
                school_owner: dt.school_owner, 
                mobile_number: dt.mobile_number , 
                user_password: dt.user_password,  
               }
              )
              /***
               "ssou_id": 1,
        "school_id": 7,
        "school_name": "Zigi",
        "users_id": 46,
        "school_owner": "Rashid Juma Ahmad",
        "mobile_number": "0711222444",
        "user_password": "0711222444"

               * ***/
              //console.log(" x0x0 dt.full_name=" + dt.full_name)
            })
        }
       
       // console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
        
        setOrganizationSchoolsData(newList)
      }
      
    
      /*** *
         
      useEffect(()=>{
          
        let APIURL= APIROOTURL + "SingleTeacherSubjectsViewEXT/" + schoolId + "/" + usersId
        let headerOptions={
            method: 'GET',
        }
    
        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json =>{
         console.log("json 123 =" + json);
         console.log("json 5123 =" + json[0]['name']);
         console.log("json 123 =" + json[0].name);
         loadOrganizationSchoolsData(json)
        })
        .catch(error=> console.log("error=" + error))
        
        },[])
        ***/

        /*** */

        useEffect(()=>{
          
            let APIURL= APIROOTURL + "SchoolOwnersBySingleOwnerViewEXT/" + usersIdEXT
            let headerOptions={
                method: 'GET',
            }
        
            fetch(APIURL, headerOptions)
            .then( response => response.json())
            .then( json =>{
             console.log("json 123 =" + json);
             console.log("json 5123 =" + json[0]['name']);
             console.log("json 123 =" + json[0].name);
             loadOrganizationSchoolsData(json)
            })
            .catch(error=> console.log("error=" + error))
            
            },[])
           /*****/


           
        useEffect(()=>{
          
          let APIURL= APIROOTURL + "SchoolOwnersBySingleOwnerViewEXT/" + usersIdEXT
          let headerOptions={
              method: 'GET',
          }
      
          fetch(APIURL, headerOptions)
          .then( response => response.json())
          .then( json =>{
           console.log("json 123 =" + json);
           console.log("json 5123 =" + json[0]['name']);
           console.log("json 123 =" + json[0].name);
           loadOrganizationSchoolsData(json)
          })
          .catch(error=> console.log("error=" + error))
          
          },[refreshIt])
         /*****/
    

        
const validateForm = (data) =>{
    const errors={};
    

    //console.log("01 " + ", data.first_name=" + data.first_name)
    //alert(data.sub_class_id)
    if(data.school==="0" || data.school=="0" || data.school===0 || data.school==0 ){
       // console.log("if " + ", data.first_name=" + data.first_name)
        errors.school='Please select stream';
    }
    
    //alert(data.subject_id)
    
    return errors;
  
  }
  

    //formDataUserLoginEXT  AddSchoolToOrganizationView     sendDataToParent
    const AddSchoolToOrganization=()=>{
        
         let newErrors=validateForm(formDataUserLoginEXT);
         setErrors(newErrors);
         
         console.log("errors.lenght=" + Object.keys(newErrors).length)
         if(Object.keys(newErrors).length===0){
           console.log("len0")
           AddSchoolToOrganizationDetails()
         }
         else{
           console.log("len1")
         }
         
    }


    
   const AddSchoolToOrganizationDetails=()=>{
  
    //alert( schoolId + "," + usersId)
    //return;
     
    //let url = API_URL;      AddSchoolToOwnerView
    let APIURL= APIROOTURL + "AddSchoolToOwnerViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formDataUserLoginEXT, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data.msg=" + res.data.msg)
       
        //User login was successful    School was successfully allocated to the owner
       if (res.data.msg==="School was successfully allocated to the owner"){
        //
        alert("School was successfully allocated to the owner")
       // setButtonClicked(!buttonClicked)
        setRefreshIt(!refreshIt)
       //  
       }
       else if (res.data.msg==="A user with similar mobile numbers has already been created"){
        //
        alert("A user with similar mobile numbers has already been created")
       //  
       }
       else{
        alert("Creating School Admin failed");
       }
       //

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));

   }   



   
  return (
    <Stack direction="column" spacing={1}>

    <Stack direction="row" spacing={1}>
     <Box flex={3}>
     </Box>
     <Box flex={6}>
            <Typography
              variant="h5"
              
              sx={{ m: "15px 0 5px 20px" }}
            >
              UPDATE ORGANIZATION SCHOOLS FOR {full_name} - {users_id}
            </Typography>
            
            {/*** *
            <Typography
              variant="h5"
              
              sx={{ m: "15px 0 5px 20px" }}
            >
             ORGANIZATION: {organization_name}
            </Typography>
             ***/}
           
        {/***
        <TXTRoundedDiv>
           <StyledInput
            name="name"
            placeholder="School name"
            onChange={handleChangeInput}
           />
           { errors.name && (<span> errors.name </span>)}
         </TXTRoundedDiv>
         ***/} 
          
           
           <TXTRoundedDiv>
              <Select
                  name="school"
                  placeholder="Select school"
                  options={schools}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.school && (<span> {errors.school} </span>)}
         </TXTRoundedDiv>
          
         {/*** *

         <TXTRoundedDiv>
              <Select
                  name="sub_class"
                  placeholder="Select stream"
                  options={subClasses}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.sub_class && (<span> {errors.sub_class} </span>)}
         </TXTRoundedDiv>
          
          ***/}
          {/***
           <TXTRoundedDiv>
              <Select
                  name="gender"
                  placeholder="Select gender"
                  options={patientGender}
                  styles={customStyles}
                  
                  onChange={handleChangeSelect}
              />
              {errors.gender && (<span> {errors.gender} </span>)}
         </TXTRoundedDiv>
          ***/}  
           
         
      <TXTNonVisibleDiv>
      <Button type="Submit"  
      color="secondary" 
      variant="contained" 
      onClick={AddSchoolToOrganization}
     
      >
       ADD SCHOOL
      </Button>
      </TXTNonVisibleDiv>
      
      
      

     </Box>
     <Box flex={3}>
    
     </Box>
     
    </Stack>
    
    <Stack  direction="row" spacing={1} style={{ marginTop: '20px'}}>

    <Box flex={1}>
    </Box>

    <Box flex={10}>
         
        <DataGrid checkboxSelection rows={organizationSchoolsData} columns={columns} />
    </Box>

    <Box flex={1}>

    </Box>
      

    </Stack>

    </Stack>
    
  )
}
